!function (n, r) {
  !function () {
    function n(n, r) {
      var t = o(n);
      if (10 !== t.length) return !1;
      if (r && !r(t)) return !1;
      var e = t.split("").reduce(function (n, r, t) {
        return n + r * f[t];
      }, 0),
          a = 11 - e % 11,
          u = parseInt(t.substr(8, 1), 0);
      return 11 == a && 0 === u || a === u;
    }

    function r(n) {
      var r = parseInt(n.substr(0, 2), 10);
      return r > 0 && r <= 31;
    }

    function t(n) {
      var r = parseInt(n.substr(0, 2), 10);
      return r > 40 && r <= 71;
    }

    function e(n, t) {
      function e(n) {
        var t = "" + Math.floor(10 * Math.random()),
            a = "" + Math.floor(10 * Math.random());
        if (r(n)) var t = "" + Math.floor(8 * Math.random() + 2);

        for (var u = n + t + a, o = 0, i = 0; i < 8; i++) o += u[i] * f[i];

        return o = 11 - o % 11, o = 11 == o ? 0 : o, 10 == o ? e(n) : t + a + o;
      }

      var a = "",
          u = n.getDate();
      u < 10 && (u = "0" + u), u = "" + u, u = t(u), a += u;
      var o = n.getMonth();
      o += 1, o < 10 && (o = "0" + o), o = "" + o, a += o;
      var i = n.getFullYear();
      i = "" + i, i = i[2] + i[3], a += i, a += e(a);
      var i = n.getFullYear();
      return i = "" + i, a += i[1];
    }

    function a(n) {
      return n;
    }

    function u(n) {
      return "" + (parseInt(n, 10) + 40);
    }

    function o(n) {
      var r = "" + n;
      return r = r.replace(/(\D)+/g, ""), 9 === r.length && (r = "0" + r), r;
    }

    var i = {};
    i.isValid = function (e) {
      var a = n(e, r),
          u = n(e, t);
      return a || u;
    }, i.isPerson = function (t) {
      return n(t, r);
    }, i.isCompany = function (r) {
      return n(r, t);
    }, i.clean = function (n) {
      return o(n);
    }, i.format = function (n, r) {
      var t = o(n);
      return r = void 0 !== r ? r : "-", t = t.substring(0, 6) + r + t.substring(6, 10);
    }, i.generatePerson = function (n) {
      return e(n, a);
    }, i.generateCompany = function (n) {
      return e(n, u);
    }, i.info = function (e) {
      var a = {};
      a.kt = o(e);
      var u = n(e, r),
          i = n(e, t);

      if (u || i) {
        a.valid = !0, a.type = !0 === u ? "person" : "company";
        var f = o(e),
            s = f.substring(0, 2);
        s > 31 && (s -= 40);
        var c = f.substring(2, 4),
            v = (0 == f.substring(9, 10) ? 20 : 19) + f.substring(4, 6),
            d = new Date(v, c - 1, s);
        a.birthday = d, a.birthdayReadable = d.toDateString();
        var l = new Date(),
            g = l - d,
            p = Math.floor(g / (864e5 * 365.2422));
        return a.age = p, a;
      }

      return a.valid = !1, a;
    };
    var f = [3, 2, 7, 6, 5, 4, 3, 2, 0, 0];
    "undefined" != typeof module && module.exports ? module.exports = i : "function" == typeof define && define.amd ? define(i) : window && (window.kennitala = i);
  }(), r[""] = n;
}({}, function () {
  return this;
}());